import * as React from 'react';
import * as ReactNative from 'react-native';
import * as ReactRedux from 'react-redux';
import * as ReactNavigationNative from '@react-navigation/native';
import * as AsyncStorage from '@react-native-async-storage/async-storage';
import * as AuthReducer from './src/reducers/cbcAuthorizationSlice';
import * as StyledComponentsNative from 'styled-components/native';
import * as CommonStyles from './src/styles/common-styles';
import * as BugSnag from '@bugsnag/expo';
import * as SecureStore from 'expo-secure-store';
import * as ForgotPassword from './src/components/ForgotPassword';
import * as LinearGradient from 'expo-linear-gradient';
import * as cbcAccountActionsSlice from './src/reducers/cbcAccountActionsSlice';
import * as cbcActivityActionsSlice from './src/reducers/cbcActivityActionsSlice';
import * as cbcActivityScoresSlice from './src/reducers/cbcActivityScoresSlice';
import * as cbcLoggingSlice from './src/reducers/cbcLoggingSlice';
import * as cbcStreakSlice from './src/reducers/cbcStreakSlice';
import * as cbcWorkoutSlice from './src/reducers/cbcWorkoutSlice';
import * as useWindowDimensions from './src/hooks/useWindowDimensions';
import * as AudioLibrary from './src/hooks/AudioLibrary';
import * as ActivityLookupTable from './src/hooks/ActivityLookupTable';
import * as PivotLogging from './src/hooks/PivotLogging';
import * as cbcActivitiesSlice from './src/reducers/cbcActivitiesSlice';
import * as useWorkoutState from './src/hooks/useWorkoutState';
import * as ActivityButton from './src/components/ActivityButton';
import * as TodaysWorkout from './src/components/dashboard/TodaysWorkout';
import * as ActivityContainer from './src/components/ActivityContainer';
import * as ActivityList from './src/components/ActivityList';
import * as ActivityRow from './src/components/ActivityRow';
import * as ActivityStartScreen from './src/components/ActivityStartScreen';
import * as AudioPlayer from './src/components/AudioPlayer';
import * as CbcSettings from './src/components/CbcSettings';
import * as ContinueWorkout from './src/components/ContinueWorkout';
import * as DynamicComponent from './src/components/DynamicComponent';
import * as DynamicLogin from './src/components/DynamicLogin';
import * as GameView from './src/components/GameView';
import * as LoadScreen from './src/components/LoadScreen';
import * as Login from './src/components/Login';
import * as ScoreBar from './src/components/ScoreBar';
import * as SettingsBar from './src/components/SettingsBar';
import * as TimerBar from './src/components/TimerBar';
import * as WorkoutIntroduction from './src/components/WorkoutIntroduction';
import * as AudioCoherenceTraining from './src/components/activities/ACT/AudioCoherenceTraining';
import * as BreatherElement from './src/components/activities/ACT/BreatherElement';
import * as MyNotifications from './src/components/dashboard/MyNotifications';
import * as WorkoutDashboard from './src/components/dashboard/WorkoutDashboard';
import * as WorkoutScience from './src/components/dashboard/WorkoutScience';
import * as AchievementBadge from './src/components/dashboard/achievements/AchievementBadge';
import * as WorkoutAchievements from './src/components/dashboard/achievements/WorkoutAchievements';
import * as EvaluationProgressBar from './src/components/dashboard/evaluation-progress/EvaluationProgressBar';
import * as EvaluationProgressNumber from './src/components/dashboard/evaluation-progress/EvaluationProgressNumber';
import * as WorkoutEvaluationProgress from './src/components/dashboard/evaluation-progress/WorkoutEvaluationProgress';
import * as ScoreKey from './src/components/dashboard/shared/ScoreKey';
import * as CoreFocus from './src/components/dashboard/training-plan/CoreFocus';
import * as WorkoutTrainingPlan from './src/components/dashboard/training-plan/WorkoutTrainingPlan';
import * as StatLine from './src/components/dashboard/workout-stats/StatLine';
import * as WorkoutStats from './src/components/dashboard/workout-stats/WorkoutStats';
import * as StreakCalendar from './src/components/dashboard/workout-streak/StreakCalendar';
import * as StreakDay from './src/components/dashboard/workout-streak/StreakDay';
import * as StreakRow from './src/components/dashboard/workout-streak/StreakRow';
import * as WorkoutStreak from './src/components/dashboard/workout-streak/WorkoutStreak';
import * as config from './src/config';
import * as Ionicons from '@expo/vector-icons/Ionicons';
import * as VectorIcons from '@expo/vector-icons';
import * as ExpoAv from 'expo-av';
import * as Slider from '@react-native-community/slider';
import * as ReactWebView from 'react-native-webview'
import * as useLocalNotificationJSONManager from "./src/hooks/useLocalNotificationJSONManager";
import * as localNotificationHandler from "./src/hooks/localNotificationHandler";
import * as BannerImage from "./assets/banner.png"
import * as ArrowGif from "./assets/arrow.gif"
import * as ReminderBanner from "./src/components/ReminderBanner";
import * as useCheckReminderMessages from "./src/hooks/checkReminderMessages";

import * as navigationService from "./src/hooks/navigationService"
import * as DynamicModal from "./src/modals/DynamicModal";

const Packages = {
  react: () => React,
  BugSnag: () => BugSnag,
  'react-native': () => ReactNative,
  'react-redux': () => ReactRedux,
  '@react-navigation/native': () => ReactNavigationNative,
  '@react-native-async-storage/async-storage': () => AsyncStorage,
  cbcAuthorization: () => AuthReducer,
  'styled-components/native': () => StyledComponentsNative,
  commonStyles: () => CommonStyles,
  'expo-secure-store': () => SecureStore,
  ForgottenPassword: () => ForgotPassword,
  'expo-linear-gradient': () => LinearGradient,
  cbcAccountActionsSlice: () => cbcAccountActionsSlice,
  cbcActivityActionsSlice: () => cbcActivityActionsSlice,
  cbcActivityScoresSlice: () => cbcActivityScoresSlice,
  cbcLoggingSlice: () => cbcLoggingSlice,
  cbcStreakSlice: () => cbcStreakSlice,
  cbcWorkoutSlice: () => cbcWorkoutSlice,
  cbcActivitiesSlice: () =>  cbcActivitiesSlice,
  useWindowDimensions: () => useWindowDimensions,
  PivotLogging: () => PivotLogging,
  config: () => config,
  AudioLibrary: () => AudioLibrary,
  ActivityLookupTable: () => ActivityLookupTable,
  WorkoutScience: () => WorkoutScience,
  WorkoutTrainingPlan: () => WorkoutTrainingPlan,
  WorkoutStats: () => WorkoutStats,
  WorkoutStreak: () => WorkoutStreak,
  Ionicons: () => Ionicons,
  VectorIcons: () => VectorIcons,
  'expo-av': () => ExpoAv,
  'react-native-webview': () => ReactWebView,
  '@react-native-community/slider': () => Slider,
  'ReminderBanner': () => ReminderBanner,
  DynamicModal: () => DynamicModal,
  useCheckReminderMessages: () => useCheckReminderMessages
};

const fromPairs = (pairs) =>
  Object.assign({}, ...pairs.map(([k, v]) => ({ [k]: v })));
const AllPackages = fromPairs(
  Object.keys(Packages).map((k) => [k, () => ({ exports: Packages[k]() })])
);

export default AllPackages;
